<template>
  <div>
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.isActive"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>CNPJ/CPF</span>
          <vs-input
            size="large"
            class="w-full"
            name="CNPJ"
            id="CNPJ"
            v-model="formCadastro.cpfCnpj"
            v-validate="{
              required: true,
              min: escolherCPFCNPJMin,
            }"
            :state="validateState(veeFields, veeErrors, 'CNPJ')"
            :class="validateStateClass(veeFields, veeErrors, 'CNPJ')"
            val-icon-danger="clear"
            :danger-text="dangerText"
            v-mask="[DOCUMENT_MASK.CPF_WITH_CNPJ, DOCUMENT_MASK.CNPJ]"
            @input="formCadastro.cpfCnpj = $event.toUpperCase()"
            icon-pack="feather"
            icon="icon-user-check"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Razão Social</span>
          <vs-input
            size="large"
            class="w-full"
            name="Razão Social"
            id="Razão Social"
            v-model="formCadastro.corporateName"
            :state="validateState(veeFields, veeErrors, 'Razão Social')"
            :class="validateStateClass(veeFields, veeErrors, 'Razão Social')"
            val-icon-danger="clear"
            :danger-text="dangerText"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>N° Registro SUSEP</span>
          <vs-input
            size="large"
            class="w-full"
            name="N° Registro SUSEP"
            id="N° Registro SUSEP"
            v-mask="'#########'"
            v-model="formCadastro.susep"
            :state="validateState(veeFields, veeErrors, 'N° Registro SUSEP')"
            :class="
              validateStateClass(veeFields, veeErrors, 'N° Registro SUSEP')
            "
            val-icon-danger="clear"
            :danger-text="dangerText"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Cidade</span>
          <vs-input
            size="large"
            class="w-full"
            name="Cidade"
            id="Cidade"
            v-model="formCadastro.city"
            :state="validateState(veeFields, veeErrors, 'Cidade')"
            :class="validateStateClass(veeFields, veeErrors, 'Cidade')"
            val-icon-danger="clear"
            :danger-text="dangerText"
            icon-pack="feather"
            icon="icon-map"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Estado</span>
          <vs-input
            size="large"
            class="w-full"
            name="Estado"
            id="Estado"
            v-model="formCadastro.state"
            v-validate="{ min: 2, max: 2 }"
            :state="validateState(veeFields, veeErrors, 'Estado')"
            :class="validateStateClass(veeFields, veeErrors, 'Estado')"
            val-icon-danger="clear"
            :danger-text="dangerText"
            icon-pack="feather"
            icon="icon-navigation"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Observação</span>
          <vs-input
            size="large"
            class="w-full"
            name="Observação"
            id="Observação"
            v-model="formCadastro.observation"
            :state="validateState(veeFields, veeErrors, 'Observação')"
            :class="validateStateClass(veeFields, veeErrors, 'Observação')"
            val-icon-danger="clear"
            :danger-text="dangerText"
          />
        </div>
      </div>

      <div v-for="index in 8" :key="index" class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>CPF dos sócios {{ index }}</span>
          <vs-input
            size="large"
            class="w-full"
            :name="'CPF sócios ' + index"
            :id="'CPF sócios ' + index"
            v-model="formCadastro['partnerCpf' + index]"
            v-validate="{ min: 14 }"
            :state="validateState(veeFields, veeErrors, 'CPF sócios ' + index)"
            :class="
              validateStateClass(veeFields, veeErrors, 'CPF sócios ' + index)
            "
            val-icon-danger="clear"
            :danger-text="dangerText"
            v-mask="DOCUMENT_MASK.CPF_ONLY"
            icon-pack="feather"
            icon="icon-user-check"
            icon-no-border
          />
        </div>
      </div>

      <ErrorsAlert :errors="errors" />

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="!this.dados.id"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';
import notify from '../../utils/notify';
import utilsList from '../../utils/list';
import ErrorsAlert from '../../components/ErrorsAlert';
import cpfCnpj from '../../services/cpfCnpj';
import { FORM_MESSAGES } from '../../utils/constants';
import { DOCUMENT_MASK } from '../../constants/cpfCnpj';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
  },
  computed: {
    errors() {
      return this.$validator.errors.all();
    },
    escolherCPFCNPJMin() {
      return this.formCadastro.cpfCnpj && this.formCadastro.cpfCnpj.length <= 14
        ? 14
        : 18;
    },
    dangerText() {
      return FORM_MESSAGES.REQUIRED_FIELD;
    },
  },
  data() {
    return {
      DOCUMENT_MASK,
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      aguardeCadastro: false,
      idEmpresa: null,
      formCadastro: {
        id: null,
        isActive: true,
        cpfCnpj: '',
        corporateName: null,
        susep: null,
        city: null,
        state: null,
        observation: null,
        partnerCpf1: null,
        partnerCpf2: null,
        partnerCpf3: null,
        partnerCpf4: null,
        partnerCpf5: null,
        partnerCpf6: null,
        partnerCpf7: null,
        partnerCpf8: null,
      },
    };
  },
  methods: {
    preencheForm() {
      if (this.dados && this.dados.id) {
        this.formCadastro.id = this.dados.id;
        this.formCadastro.isActive = this.dados.isActive;
        this.formCadastro.cpfCnpj = this.dados.cpfCnpj;
        this.formCadastro.corporateName = this.dados.corporateName;
        this.formCadastro.susep = this.dados.susep;
        this.formCadastro.city = this.dados.city;
        this.formCadastro.state = this.dados.state;
        this.formCadastro.observation = this.dados.observation;
        this.formCadastro.partnerCpf1 = this.dados.partnerCpf1;
        this.formCadastro.partnerCpf2 = this.dados.partnerCpf2;
        this.formCadastro.partnerCpf3 = this.dados.partnerCpf3;
        this.formCadastro.partnerCpf4 = this.dados.partnerCpf4;
        this.formCadastro.partnerCpf5 = this.dados.partnerCpf5;
        this.formCadastro.partnerCpf6 = this.dados.partnerCpf6;
        this.formCadastro.partnerCpf7 = this.dados.partnerCpf7;
        this.formCadastro.partnerCpf8 = this.dados.partnerCpf8;
      } else {
        this.resetForm();
      }
    },

    onSubmit() {
      if (!this.formCadastro.cpfCnpj) {
        notify.notifyFail(this.$vs, 'CPF OU CNPJ Inválido');
        return;
      }

      const validado = cpfCnpj.valida_cpf_cnpj(this.formCadastro.cpfCnpj);
      if (!validado) {
        notify.notifyFail(this.$vs, 'CPF OU CNPJ Inválido');
        return;
      }

      for (let i = 1; i <= 8; i++) {
        const partnerCpf = this.formCadastro[`partnerCpf${i}`];
        if (partnerCpf && !cpfCnpj.valida_cpf_cnpj(partnerCpf)) {
          notify.notifyFail(this.$vs, `CPF do sócio ${i} é inválido`);
          return;
        }
      }

      let action = 'Atualizar';
      let msgRetorno = 'Dados Atualizados com sucesso';
      if (!this.formCadastro.id) {
        action = 'Adicionar';
        msgRetorno = 'Registro Adicionado com sucesso';
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post('BrokerBlocklist', action, this.formCadastro)
            .then(() => {
              this.aguardeCadastro = false;
              notify.notifySuccess(this.$vs, msgRetorno);
              this.$emit('concluido');
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              notify.notifyFail(this.$vs, error);
            });
        }
      });
    },
    resetForm() {
      this.formCadastro = {
        id: null,
        isActive: true,
        cpfCnpj: '',
        corporateName: null,
        susep: null,
        city: null,
        state: null,
        observation: null,
        partnerCpf1: null,
        partnerCpf2: null,
        partnerCpf3: null,
        partnerCpf4: null,
        partnerCpf5: null,
        partnerCpf6: null,
        partnerCpf7: null,
        partnerCpf8: null,
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
  },
  components: {
    BotaoSubmit,
    ErrorsAlert,
  },
};
</script>
